import NotFoundPage from "@/catchall";
import { RequirePermission } from "@/components/universal/require-permission";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/_sales-360")({
  component: SalesLayout,
});

function SalesLayout() {
  return (
    <RequirePermission permission="sales_360" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
